import { Instance } from 'mobx-state-tree';
import { Secretariat } from '../store/models';
import { uphocLogo, applLogo, cerpanLogo, apnlLogo, urpcLogo, upveLogo } from '../assets';

export const getSecretariatLogo = (secretariat: Instance<typeof Secretariat> | undefined) => {
  if (secretariat !== undefined && secretariat.code !== undefined) {
    switch (secretariat.code) {
      case 'APNL':
        return apnlLogo;
      case 'APPL':
        return applLogo;
      case 'CERPAN':
        return cerpanLogo;
      case 'URPC':
          return urpcLogo;
      case 'UPVE':
          return upveLogo;
      case 'UPHOC':
      default:
        return uphocLogo;
    }
  }
  return uphocLogo;
};
